import { useAuth0 } from "@auth0/auth0-react";
import FilterListIcon from "@material-ui/icons/FilterList";
import { ReactComponent as FilterIcon } from "assets/icons/filter-icon.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import CrossSvg from "assets/icons/svg/cross";
import { InputField, LabelField, MyCheckbox, SelectField } from "components";
import { MenuMultiCheckBox } from 'components/MenuMultiCheckBox/MenuMultiCheckBox';

import Button from "components/button/Button";
import FilterTabs from "components/filterTabs/FilterTabs";
import MyButton from "components/MyButton";
import { useFormik } from "formik";
import { getDateFormat, getDateFormatForDatePicket } from "helper/dateFormat";
import { getCurrency } from "helper/numberFormat";
import { useDisableEnterKey, useSearch } from "hook";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import FinanceService from "../../Lib/API/Finance";
const selectControlStyles = {
  backgroundColor: "#FFFFFF",
  borderColor: "#FFFFFF",
  color: "#b5b5c3",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
};

const OverdueDaysList = [
  {
    label: "days",
    value: "1",
  },
  {
    label: "week",
    value: "7",
  },
  {
    label: "month",
    value: "30",
  },
  {
    label: "quarter",
    value: "182",
  },
  {
    label: "year",
    value: "365",
  },
];

const installmentStatusOptions = [
  { label: "Active", value: "active" },
  { label: "On-hold", value: "on-hold" },
  { label: "Disabled", value: "disable" },
  { label: "Completed", value: "completed" },
];

const recurringStatusOptions = [
  { label: "Active", value: "active" },
  { label: "On-hold", value: "on-hold" },
  { label: "Disabled", value: "disable" },
  { label: "Completed", value: "completed" },
];

const chargeStatusOptions = [
  {
    label: "open",
    value: "open",
  },
  {
    label: "closed",
    value: "closed",
  },
  {
    label: "partially paid",
    value: "partially paid",
  },
  {
    label: "reversal",
    value: "reversal",
  },
];

const paymentStatusOptions = [
  {
    label: "prepaid",
    value: "prepaid",
  },
  {
    label: "reversal",
    value: "reversal",
  },
  {
    label: "partially applied",
    value: "partialy applied",
  },
  {
    label: "close",
    value: "close",
  },
];

export const FinanceFilter = ({
  filter,
  onChargeDateChange,
  onAccountChange,
  onIdChange,
  onPaidDateChange,
  onAmountChange,
  onChargedStatusChange,
  onPaymentStatusChange,
  onOverdueDaysChange,
  setGoSetting,
  goSetting,
  onClear,
  onStatusChange,
  setTabClick,
  setFilters,
  initialFilters,
  toggle,
  localFormat,
  setDateRange,
  setPaidRange,
  startDate,
  startPaidDate,
  endPaidDate,
  endDate,
  setCalender,
  loadingForDisable,
  switchType,
  setSwitchType,
  onFieldChange,
  onFilterGoClicked,
  openFilter: openFilterProp,
  setOpenFilter: setOpenFilterProp,
}) => {
  const [openFilterInternal, setOpenFilterInternal] = useState(false);
  const openFilter = openFilterProp !== undefined ? openFilterProp : openFilterInternal;
  const setOpenFilter = setOpenFilterProp || setOpenFilterInternal;

  const hasActiveFilter = (f) => {
    if (!f?.filter) return false;
    const { hidden, ...rest } = f.filter;
    return Object.values(rest).some((v) => v !== undefined && v !== null && v !== "" && !(Array.isArray(v) && v.length === 0));
  };
  const [ledgers, setLedgers] = useState(false);
  const [subLedgerOptions, setSubLedgerOptions] = useState();
  const { getAccessTokenSilently } = useAuth0();
  const [onSearch, setOnSearch] = useState("");
  const { searchAction } = useSearch({ action: setOnSearch });
  const [loading, setLoading] = useState(false);
  const [accounts, setData] = useState();

  const currency = getCurrency();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,1})/s;

  const [date, setDate] = useState([]);
  const [pdDate, setPdDate] = useState([]);
  const validate = (values) => {
    const errors = {};
    if (
      (values?.id?.length > 24 || values?.id?.length < 24) &&
      values?.id?.length !== 0
    ) {
      errors.id = "Id must be 24 characters";
    }

    return errors;
  };
  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: { all_ledger_sub_data: [], ledger: [], subLedger: [] },
    validate,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };


  useDisableEnterKey(true);

  useEffect(() => {
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getACcountNames(token, onSearch)
        .then((res) => {
          if (res?.accounts) {
            res.accounts.map((item) => {
              item.label = item.family_name;
              item.value = item.account_id;
              return item;
            });
            setData(res?.accounts);
          }
          enableLoading(false);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }

    fetchMyAPI();
  }, [onSearch, getAccessTokenSilently]);

  const enableLoading = (value) => {
    setLoading(value);
  };

  useEffect(() => {
    if (endDate < startDate) {
      toastr.error("End Date should be greater than start date.");
      setDateRange([null, null]);
      setDate([]);
    }
  }, [endDate]);

  useEffect(() => {
    if (endPaidDate < startPaidDate) {
      toastr.error("End Date should be greater than start date.");
      setPaidRange([null, null]);
      setPdDate([]);
    }
  }, [endPaidDate]);

  useEffect(() => {
    onChargeDateChange(formik.values?.charged_date);
    onFieldChange("ledger", formik.values?.ledger);
    onAccountChange(formik.values?.account_name);
    onIdChange(formik.values?.id);
    onPaidDateChange(formik.values?.paid_at);
    onAmountChange(formik.values?.amount);
    onChargedStatusChange(formik.values?.charge_status?.length ? formik.values.charge_status : undefined);
    onPaymentStatusChange(formik.values?.payment_status?.length ? formik.values.payment_status : undefined);
    onOverdueDaysChange(formik.values?.overdue);
    onFieldChange("subLedger", formik.values?.subLedger);
    onFieldChange("nonMember", formik.values?.nonMember);
    onFieldChange("isInstallment", formik.values?.isInstallment);
    onFieldChange("isRecurring", formik.values?.isRecurring);
    onFieldChange("installmentStatus", formik.values?.installmentStatus?.length ? formik.values.installmentStatus : undefined);
    onFieldChange("recurringStatus", formik.values?.recurringStatus?.length ? formik.values.recurringStatus : undefined);
    onFieldChange("checkNumber", formik.values?.checkNumber?.trim()?.length ? formik.values?.checkNumber : undefined);
    onFieldChange("includeAccountInformation", formik.values?.includeAccountInformation);

  }, [formik.values]);

  useEffect(() => {
    if (switchType === "charge") {
      formik.setFieldValue("checkNumber", undefined);
    }
    if (switchType === "payment") {
      formik.setFieldValue("nonMember", undefined);
      formik.setFieldValue("isInstallment", undefined);
      formik.setFieldValue("isRecurring", undefined);
      formik.setFieldValue("installmentStatus", undefined);
      formik.setFieldValue("recurringStatus", undefined);
    }
  }, [switchType]);

  useEffect(() => {
    async function getLedgeraccounts() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerList(token);
      if (res?.ledgers) {
        const arrayWithSelectAll = ['Select All', ...res?.ledgers]
        setLedgers(arrayWithSelectAll);
        setLoading(false);
      }
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  const onFilterClear = () => {
    setSubLedgerOptions([]);
    formik.setFieldValue("charged_date", undefined);
    formik.setFieldValue("ledger", []);
    formik.setFieldValue("subLedger", []);
    formik.setFieldValue("all_ledger_sub_data", []);
    formik.setFieldValue("paid_at", undefined);
    formik.setFieldValue("amount", "");
    formik.setFieldValue("charge_status", []);
    formik.setFieldValue("payment_status", []);
    formik.setFieldValue("overdue", undefined);
    formik.setFieldValue("account_name", undefined);
    formik.setFieldValue("id", "");
    formik.setFieldValue("nonMember", undefined);
    formik.setFieldValue("checkNumber", undefined);
    formik.setFieldValue("isInstallment", undefined);
    formik.setFieldValue("isRecurring", undefined);
    formik.setFieldValue("installmentStatus", undefined);
    formik.setFieldValue("recurringStatus", undefined);
    formik.setFieldValue("includeAccountInformation", undefined);
    setDateRange([null, null]);
    setPaidRange([null, null]);
    setDate([]);
    setPdDate([]);
    onClear();
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };

  const filter_by = switchType === "charge" ? ["All", "Charge", "Payment", "COA"] : ["All", "COA"];
  const filterTabs = switchType === "charge" ? [
    {
      title: "All",
      value: "All",
    },
    {
      title: "Charge",
      value: "Charge",
      dotColor: "#FBA12C",
    },
    {
      title: "Payment",
      value: "Payment",
      dotColor: "#81DC91",
    },
    {
      title: "COA",
      value: "COA",
      dotColor: "#81DC91",
    }
  ] : [
    {
      title: "All",
      value: "All",
    },
    {
      title: "COA",
      value: "COA",
      dotColor: "#81DC91",
    }
  ];

  useEffect(() => {
    if (toggle === "Transaction") {
      setFilters(initialFilters);
    }
  }, [toggle]);


  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };

  const selectCurrentStatus = () => {
    const isStatusIncluded = filter_by?.map(item => item?.toLowerCase()).includes(filter?.status?.toLowerCase());

    if (filter?.filter?.charge_type === "credit_on_account") {
      return "COA";
    }
    else if (switchType === "payment" && filter?.filter?.charge_status === "partially_paid") {
      return "Partial";
    }
    else if (switchType === "payment" && filter?.filter?.charge_status === "closed") {
      return "Paid";
    }
    else if (switchType === "charge" && isStatusIncluded) {
      return filter?.status;
    }
    return "All";
  }

  return (
    <div className="filteration">
      <div className="activated-ledger d-flex flex-column flex-lg-row align-items-center justify-content-end mb-5">
        <FilterTabs tabs={filterTabs} tabTextWeight={400} activeTab={selectCurrentStatus()} onTabsChange={(tab) => {
          onStatusChange(tab?.value);
        }} />
        <div className="pl-5">
          <Button
            style={openFilter ? { opacity: 0.3, fontWeight: 500 } : { fontWeight: 500 }}
            variant="filter"
            onClick={() => {
              setOpenFilter(!openFilter);
              setGoSetting(!goSetting);
            }}
          >
            <FilterIcon />
            <span>Filter</span>
          </Button>
        </div>
      </div>
      {hasActiveFilter(filter) && !openFilter && (() => {
        const f = filter?.filter || {};
        const chipStyle = (red) => ({
          display: "inline-flex", alignItems: "center", gap: 6,
          background: red ? "#fee2e2" : "#f1f5f9",
          color: red ? "#b91c1c" : "#334155",
          border: `1px solid ${red ? "#fca5a5" : "#cbd5e1"}`,
          borderRadius: 99, padding: "3px 10px 3px 12px",
          fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
        });
        const xBtn = (onClick) => (
          <span style={{ cursor: "pointer", fontSize: 14, lineHeight: 1, fontWeight: 400 }} onClick={onClick}>×</span>
        );
        const go = () => onFilterGoClicked();
        const chips = [
          f.overdue && (
            <span key="overdue" style={chipStyle()}>
              Overdue &gt;{f.overdue} days
              {xBtn(() => { onOverdueDaysChange({ value: undefined }); formik.setFieldValue("overdue", undefined); go(); })}
            </span>
          ),
          f.charge_date && (
            <span key="charge_date" style={chipStyle()}>
              Due: {f.charge_date.start} – {f.charge_date.end}
              {xBtn(() => { onChargeDateChange(undefined); formik.setFieldValue("charged_date", undefined); setDateRange([null, null]); go(); })}
            </span>
          ),
          f.paid_at && (
            <span key="paid_at" style={chipStyle()}>
              Paid: {f.paid_at.start} – {f.paid_at.end}
              {xBtn(() => { onPaidDateChange(undefined); formik.setFieldValue("paid_at", undefined); setPaidRange([null, null]); go(); })}
            </span>
          ),
          f.accountId && (
            <span key="account" style={chipStyle()}>
              Account: {formik.values?.account_name?.label || formik.values?.account_name?.family_name || "Selected"}
              {xBtn(() => { onAccountChange(undefined); formik.setFieldValue("account_name", undefined); go(); })}
            </span>
          ),
          f.amount && (
            <span key="amount" style={chipStyle()}>
              Amount: {f.amount}
              {xBtn(() => { onAmountChange(undefined); formik.setFieldValue("amount", ""); go(); })}
            </span>
          ),
          f.charge_status?.length && (
            <span key="charge_status" style={chipStyle()}>
              Status: {f.charge_status.join(", ")}
              {xBtn(() => { onChargedStatusChange([]); formik.setFieldValue("charge_status", []); go(); })}
            </span>
          ),
          f.payment_status?.length && (
            <span key="payment_status" style={chipStyle()}>
              Payment: {f.payment_status.join(", ")}
              {xBtn(() => { onPaymentStatusChange([]); formik.setFieldValue("payment_status", []); go(); })}
            </span>
          ),
          f.id && (
            <span key="id" style={chipStyle()}>
              ID: {f.id}
              {xBtn(() => { onIdChange(undefined); formik.setFieldValue("id", undefined); go(); })}
            </span>
          ),
          f.ledger?.length && (() => {
            const names = (formik.values?.all_ledger_sub_data || [])
              .filter(v => v?.type === "ledger")
              .map(v => v?.label)
              .filter(Boolean);
            const display = names.length
              ? (names.length > 2 ? `${names.slice(0, 2).join(", ")} +${names.length - 2}` : names.join(", "))
              : `${f.ledger.length} selected`;
            return (
              <span key="ledger" style={chipStyle()}>
                Ledger: {display}
                {xBtn(() => { onFieldChange("ledger", []); onFieldChange("subLedger", []); formik.setFieldValue("ledger", []); formik.setFieldValue("subLedger", []); formik.setFieldValue("all_ledger_sub_data", []); go(); })}
              </span>
            );
          })(),
          f.subLedger?.length && (() => {
            const names = (formik.values?.all_ledger_sub_data || [])
              .filter(v => v?.type === "sub_ledger")
              .map(v => v?.label)
              .filter(Boolean);
            const display = names.length
              ? (names.length > 2 ? `${names.slice(0, 2).join(", ")} +${names.length - 2}` : names.join(", "))
              : `${f.subLedger.length} selected`;
            return (
              <span key="subLedger" style={chipStyle()}>
                Sub-Ledger: {display}
                {xBtn(() => { onFieldChange("subLedger", []); formik.setFieldValue("subLedger", []); go(); })}
              </span>
            );
          })(),
          f.checkNumber && (
            <span key="check" style={chipStyle()}>
              Check: {f.checkNumber}
              {xBtn(() => { onFieldChange("checkNumber", undefined); formik.setFieldValue("checkNumber", undefined); go(); })}
            </span>
          ),
          f.nonMember && (
            <span key="nonMember" style={chipStyle()}>
              Non-Member
              {xBtn(() => { onFieldChange("nonMember", undefined); formik.setFieldValue("nonMember", undefined); go(); })}
            </span>
          ),
          f.isInstallment && (
            <span key="installment" style={chipStyle()}>
              Installment
              {xBtn(() => { onFieldChange("isInstallment", undefined); formik.setFieldValue("isInstallment", undefined); go(); })}
            </span>
          ),
          f.isRecurring && (
            <span key="recurring" style={chipStyle()}>
              Recurring
              {xBtn(() => { onFieldChange("isRecurring", undefined); formik.setFieldValue("isRecurring", undefined); go(); })}
            </span>
          ),
          f.installmentStatus?.length && (
            <span key="installmentStatus" style={chipStyle()}>
              Install. Status: {f.installmentStatus.join(", ")}
              {xBtn(() => { onFieldChange("installmentStatus", undefined); formik.setFieldValue("installmentStatus", []); go(); })}
            </span>
          ),
          f.recurringStatus?.length && (
            <span key="recurringStatus" style={chipStyle()}>
              Recur. Status: {f.recurringStatus.join(", ")}
              {xBtn(() => { onFieldChange("recurringStatus", undefined); formik.setFieldValue("recurringStatus", []); go(); })}
            </span>
          ),
        ].filter(Boolean);

        if (!chips.length) return null;
        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12, alignItems: "center" }}>
            {chips}
            {chips.length > 1 && (
              <span
                style={{ fontSize: 12, color: "#64748b", cursor: "pointer", textDecoration: "underline", paddingLeft: 4 }}
                onClick={() => { onFilterClear(); go(); }}
              >
                Clear all
              </span>
            )}
          </div>
        );
      })()}
      {openFilter && (
        <div className="filter mb-10">
          <Link></Link>
          <div className=" text-right px-5 pt-5">
            <span
              className="cursor-pointer"
              onClick={() => setOpenFilter(false)}
            >
              <CrossSvg />
            </span>
          </div>
          <div className="row pr-12 pl-9 finance-tilter ">
            <div className="col-sm-3 col-md-3 charged_date">
              <LabelField title={"Due Date"} />
              <DateRangePicker
                format={dateFormate}
                placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                cleanable={true}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                style={{
                  display: "inline-block",
                  padding: "0",
                  border: "0",
                  width: "100%",
                  color: "black",
                }}
                size="lg"
                value={date}
                onChange={(update) => {
                  setDateRange(update);
                  setDate(update);
                  formik.setFieldValue("charged_date", update);
                }}
              />
            </div>

            <div className="col-sm-3 col-md-3 charged_date">
              <LabelField title={"Paid Date"} />
              <DateRangePicker
                format={dateFormate}
                placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                cleanable={true}
                style={{
                  display: "inline-block",
                  padding: "0",
                  border: "0",
                  width: "100%",
                  color: "black",
                }}
                size="lg"
                value={pdDate}
                onChange={(update) => {
                  setPaidRange(update);
                  setPdDate(update);
                  formik.setFieldValue("paid_at", update);
                }}
              />
            </div>

            <div className="col-sm-3 col-md-3 charged_date">
              <LabelField title={"Ledger Account"} />
              <MenuMultiCheckBox Items={ledgers} formik={formik} loading={loading} isLedger={true} field='all_ledger_sub_data' withBorder={false} width="100%" />
            </div>
            <div className="col-sm-3 col-md-3 pb-8">
              <InputField
                type="number"
                {...{
                  formik,
                  title: "Amount",
                  name: "amount",
                  placeholderIcon: (
                    <span className="filter-amount-placeholder">{currency}</span>
                  ),
                  placeholder: "Amount",
                  value: formik.values?.amount,
                }}
                onKeyPress={(e) =>
                  formik.setFieldValue(`amount`, e.target.value.match(regex)[0])
                }
                onKeyDown={(e) => preventArrows(e)}
                min="0"
                onChange={onAmountChange}
              />
            </div>
            <div className="col-sm-3 col-md-3">
              <LabelField title={"Account Name"} />
              <Select
                {...{
                  formik,
                  name: `account_name`,
                  checkValidation: false,
                }}
                isClearable={formik.values?.account_name?.id ?? false}
                onInputChange={(text) => searchAction(text)}
                classNamePrefix="react-select"
                formatOptionLabel={formatOptionLabel}
                options={accounts}
                isLoading={loading}
                styles={colourStyles}
                onChange={(value) => {
                  if (!value) {
                    formik.setFieldValue(`account_name`, undefined);
                    return;
                  }
                  formik.setFieldValue(`account_name`, {
                    id: value._id,
                    name: value.label,
                  });
                }}
                value={{
                  label: formik.values?.account_name?.name,
                  value: formik.values?.account_name?.id,
                }}
                components={{ DropdownIndicator }}
              />
            </div>
            {switchType !== "payment" && (
              <div className="col-sm-3 col-md-3">
                <InputField
                  type="number"
                  {...{
                    formik,
                    title: "Overdue Days",
                    name: "overdue_days_input",
                    placeholder: "Enter days",
                    value: formik.values?.overdue?.value ?? "",
                  }}
                  min="0"
                  onKeyDown={(e) => preventArrows(e)}
                  handleChange={(e) => {
                    const val = e.target.value;
                    if (!val) {
                      formik.setFieldValue(`overdue`, undefined);
                      onOverdueDaysChange({ value: undefined });
                      return;
                    }
                    formik.setFieldValue(`overdue`, { label: val, value: +val });
                    onOverdueDaysChange({ value: +val });
                  }}
                />
              </div>
            )}
            {switchType !== "payment" && (
              <div className="col-sm-3 col-md-3">
                <LabelField title={"Charged Status"} />
                <Select
                  isMulti
                  classNamePrefix="react-select"
                  options={chargeStatusOptions}
                  styles={colourStyles}
                  value={formik.values?.charge_status || []}
                  onChange={(selected) => formik.setFieldValue("charge_status", selected || [])}
                  components={{ DropdownIndicator }}
                  placeholder="Select status..."
                />
              </div>
            )}
            <div className="col-sm-3 col-md-3">
              <LabelField title={"Payment Status"} />
              <Select
                isMulti
                classNamePrefix="react-select"
                options={paymentStatusOptions}
                styles={colourStyles}
                value={formik.values?.payment_status || []}
                onChange={(selected) => formik.setFieldValue("payment_status", selected || [])}
                components={{ DropdownIndicator }}
                placeholder="Select status..."
              />
            </div>
            <div className={`col-sm-3 col-md-3${switchType === "charge" ? " mt-4" : ""}`}>
              <InputField
                type="text"
                {...{
                  formik,
                  title: "Id",
                  name: "id",
                  placeholder: "Transaction / Charge / Payment #",
                  value: formik.values?.id,
                }}
                onKeyPress={(e) => formik.setFieldValue(`id`, e.target.value)}
                onKeyDown={(e) => preventArrows(e)}
                onChange={onIdChange}
              />
              <div style={{ color: "red", height: "1rem" }}>
                {formik.errors.id ? formik.errors.id : null}
              </div>
            </div>
            {switchType === "charge" && (
              <>
                <div className="col-sm-6 col-md-6 d-flex align-items-center"
                  style={{
                    gap: 20,
                    marginTop: "35px"
                  }}
                >
                  <MyCheckbox
                    title="Visitors payments"
                    checked={formik.values?.nonMember || false}
                    handlechange={() => {
                      formik.setFieldValue(
                        'nonMember',
                        !formik.values?.nonMember
                      );
                    }}
                    titleStyles={{
                      fontSize: "14px"
                    }}
                  />
                  <MyCheckbox
                    title="Installments"
                    checked={formik.values?.isInstallment || false}
                    handlechange={() => {
                      const next = !formik.values?.isInstallment;
                      formik.setFieldValue('isInstallment', next);
                      if (!next) formik.setFieldValue('installmentStatus', []);
                    }}
                    titleStyles={{
                      fontSize: "14px"
                    }}
                  />
                  <MyCheckbox
                    title="Recurring"
                    checked={formik.values?.isRecurring || false}
                    handlechange={() => {
                      const next = !formik.values?.isRecurring;
                      formik.setFieldValue('isRecurring', next);
                      if (!next) formik.setFieldValue('recurringStatus', []);
                    }}
                    titleStyles={{
                      fontSize: "14px"
                    }}
                  />

                </div>
                {formik.values?.isInstallment && (
                  <div className="col-sm-3 col-md-3" style={{ marginTop: "25px" }}>
                    <LabelField title={"Installment Status"} />
                    <Select
                      isMulti
                      classNamePrefix="react-select"
                      options={installmentStatusOptions}
                      styles={colourStyles}
                      value={formik.values?.installmentStatus || []}
                      onChange={(selected) => formik.setFieldValue("installmentStatus", selected || [])}
                      components={{ DropdownIndicator }}
                      placeholder="Select status..."
                    />
                  </div>
                )}
                {formik.values?.isRecurring && (
                  <div className="col-sm-3 col-md-3" style={{ marginTop: "25px" }}>
                    <LabelField title={"Recurring Status"} />
                    <Select
                      isMulti
                      classNamePrefix="react-select"
                      options={recurringStatusOptions}
                      styles={colourStyles}
                      value={formik.values?.recurringStatus || []}
                      onChange={(selected) => formik.setFieldValue("recurringStatus", selected || [])}
                      components={{ DropdownIndicator }}
                      placeholder="Select status..."
                    />
                  </div>
                )}
                <div className="col-sm-6 col-md-6 d-flex align-items-center"
                  style={{
                    gap: 20,
                    marginTop: (formik.values?.isInstallment && formik.values?.isRecurring) ? "55px" : "25px"
                  }}
                >
                  <MyCheckbox
                    title="Include account information in CSV/Excel export"
                    checked={formik.values?.includeAccountInformation || false}
                    handlechange={() => {
                      formik.setFieldValue(
                        'includeAccountInformation',
                        !formik.values?.includeAccountInformation
                      );
                    }}
                    titleStyles={{
                      fontSize: "14px"
                    }} />
                </div>
              </>
            )}
            {switchType === "payment" && (
              <><div className="col-sm-3 col-md-3">
                <InputField
                  type="text"
                  {...{
                    formik,
                    title: "Check #",
                    name: "checkNumber",
                    placeholder: "Check #",
                    value: formik.values?.checkNumber || "",
                  }}
                  onKeyPress={(e) => formik.setFieldValue(`checkNumber`, e.target.value?.trim()?.length ? e.target.value : "")}
                  onKeyDown={(e) => preventArrows(e)}
                  onChange={(e) => onFieldChange("checkNumber", e.target.value?.trim()?.length ? e.target.value : undefined)} /></div><div className="col-sm-3 col-md-3">
                </div>
                <div className="col-12 d-flex align-items-center"
                  style={{
                    gap: 20,
                    marginTop: "25px"
                  }}
                >
                  <MyCheckbox
                    title="Include account information in CSV/Excel export"
                    checked={formik.values?.includeAccountInformation || false}
                    handlechange={() => {
                      formik.setFieldValue(
                        'includeAccountInformation',
                        !formik.values?.includeAccountInformation
                      );
                    }}
                    titleStyles={{
                      fontSize: "14px"
                    }} />
                </div></>
            )}
          </div>
          <div className="pr-12 pl-9 pb-10 justify-content-end d-flex">

            <MyButton
              type="secondary"
              content={<span className="mx-8">Clear</span>}
              onClick={onFilterClear}
              style={{ marginRight: 10 }}
            />
            <button
              className="btn btn-primary"
              disabled={
                loadingForDisable || ((formik.values?.id?.length > 24 ||
                  formik.values?.id?.length < 24) &&
                  formik.values?.id?.length !== 0
                  ? true
                  : false)
              }
              style={{ width: 70 }}
              onClick={() => {
                setOpenFilter(false);
                onFilterGoClicked();
              }}
            >
              Go
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
